"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlowSettings = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const atom_1 = require("./atom");
const props_1 = require("../common/props");
const logger_1 = require("../util/logger");
const log = new logger_1.Logger("glow");
/**
 * The elevation settings atom.
 * @category Atoms
 */
class GlowSettings extends atom_1.Atom {
    constructor(atoms) {
        super("Glow Settings", false, atoms);
        this.addDependency(atoms.colorThemes);
        this.color = new props_1.PropertyString("Color", false, this, { getDefaultValue: this.getDefaultColor.bind(this) });
        this.blurRadius = new props_1.PropertyNumberRange("Blur Radius", false, this, 0, 10, 2);
        this.spreadRadius = new props_1.PropertyNumberRange("Spread Radius", false, this, 0, 10, 2);
        this.colorOpacity = new props_1.PropertyNumberRange("Color Opacity", false, this, 0, 100, 4);
        this.percentageChange = new props_1.PropertyPercentage("Percentage Change", false, this, 20);
    }
    getDefaultColor() {
        var _a;
        let defColor = "#000000";
        const ct = this.atoms.colorThemes.getDefaultTheme();
        if (ct) {
            defColor = (_a = ct.primary.getValue()) === null || _a === void 0 ? void 0 : _a.hex;
        }
        log.debug(`glowSettings.getDefaultColor: ${defColor}`);
        return defColor;
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.color.deserialize(obj.shadowColor);
        this.blurRadius.deserialize(obj.blurRadius);
        this.spreadRadius.deserialize(obj.spreadRadius);
        this.colorOpacity.deserialize(obj.colorOpacity);
        this.percentageChange.deserialize(obj.percentageChange);
    }
    serialize() {
        const obj = {};
        obj.color = this.color.serialize();
        obj.blurRadius = this.blurRadius.serialize();
        obj.spreadRadius = this.spreadRadius.serialize();
        obj.colorOpacity = this.colorOpacity.serialize();
        obj.percentageChange = this.percentageChange.serialize();
        return obj;
    }
}
exports.GlowSettings = GlowSettings;
